import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { toggleTheme } from '@/store/uiSlice';

/** Dark/light toggle. Dark is primary (spec §14); the control states the action for screen readers. */
export function ThemeToggle() {
  const theme = useAppSelector((s) => s.ui.theme);
  const dispatch = useAppDispatch();
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <Tooltip title={`Switch to ${next} theme`}>
      <Button
        type="text"
        aria-label={`Switch to ${next} theme`}
        icon={theme === 'dark' ? <SunOutlined /> : <MoonOutlined />}
        onClick={() => dispatch(toggleTheme())}
      />
    </Tooltip>
  );
}
